import script from "./Tab.vue?vue&type=script&setup=true&lang=js"
export * from "./Tab.vue?vue&type=script&setup=true&lang=js"

import "./Tab.vue?vue&type=style&index=0&id=42128094&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42128094"]])

export default __exports__